import Vue from 'vue'
import Router from 'vue-router'
import app from './routers/app.js'
import base from './routers/base.js'
import ymt from './routers/ymt.js'
import feedBack from './routers/feedBack.js'
import zex from './routers/zex.js'
import yz from './routers/yz.js'
import lx from './routers/lx.js'
import yt from './routers/yt.js'
import yx from './routers/yx.js'
let common = {
    path: '*',
    redirect: '404.htm'
}
Vue.use(Router)
export default new Router({ 
    mode: typeof (history.pushState) === 'function'?'history':'hash',
    base: process.env.BASE_URL,
    // 先注释404检查导出路径
    routes: [].concat(app,base,feedBack,common,ymt,zex,lx, yz, yt, yx)
});